module.exports = __webpack_public_path__ + "img/FullCover_Eng.fbc56b27.jpg";